import CreateTemplate from './CreateTemplate'

export default CreateTemplate
